var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopyIconSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 1.3335H6.66659C5.93125 1.3335 5.33325 1.9315 5.33325 2.66683V5.3335H2.66659C1.93125 5.3335 1.33325 5.9315 1.33325 6.66683V13.3335C1.33325 14.0688 1.93125 14.6668 2.66659 14.6668H9.33325C10.0686 14.6668 10.6666 14.0688 10.6666 13.3335V10.6668H13.3333C14.0686 10.6668 14.6666 10.0688 14.6666 9.3335V2.66683C14.6666 1.9315 14.0686 1.3335 13.3333 1.3335ZM2.66659 13.3335V6.66683H9.33325L9.33459 13.3335H2.66659ZM13.3333 9.3335H10.6666V6.66683C10.6666 5.9315 10.0686 5.3335 9.33325 5.3335H6.66659V2.66683H13.3333V9.3335Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIconSmall);
export default __webpack_public_path__ + "static/media/copy-icon-small.73079ce628633ae9a03886726a834a69.svg";
export { ForwardRef as ReactComponent };